import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ec3bd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content heightContent mortgage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center l-font-size mb--20" }, " Калькулятор подбора программ банков с искусственным интеллектом ", -1))
const _hoisted_3 = { class: "none-Mobile" }
const _hoisted_4 = { class: "mortgage__widget" }
const _hoisted_5 = { class: "only-mobile mt--20" }

import { InfoTopBar, MortgageWidget } from '@/components';

export default /*#__PURE__*/_defineComponent({
  __name: 'Mortgage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(InfoTopBar), {
        class: "mb--20",
        text: "Точность демонстрации ставки до 97%.\nБолее 75 банков по 600 программам в 85 регионах РФ."
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(MortgageWidget), { class: "mb--20" })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(InfoTopBar), { text: "Точность демонстрации ставки до 97%.\nБолее 75 банков по 600 программам в 85 регионах РФ." })
    ])
  ]))
}
}

})